var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyQuestionElementBase } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionRating = /** @class */ (function (_super) {
    __extends(SurveyQuestionRating, _super);
    function SurveyQuestionRating(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    Object.defineProperty(SurveyQuestionRating.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionRating.prototype.handleOnClick = function (event) {
        this.question.setValueFromClick(event.target.value);
        this.setState({ value: this.question.value });
    };
    SurveyQuestionRating.prototype.renderItem = function (item, index) {
        var renderedItem = ReactElementFactory.Instance.createElement(this.question.itemComponent, {
            question: this.question,
            item: item,
            index: index,
            key: "value" + index,
            handleOnClick: this.handleOnClick,
            isDisplayMode: this.isDisplayMode
        });
        return renderedItem;
    };
    SurveyQuestionRating.prototype.renderElement = function () {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        var minText = this.question.minRateDescription
            ? this.renderLocString(this.question.locMinRateDescription)
            : null;
        var maxText = this.question.maxRateDescription
            ? this.renderLocString(this.question.locMaxRateDescription)
            : null;
        return (React.createElement("div", { className: this.question.ratingRootCss, ref: function (div) { return (_this.setControl(div)); } },
            React.createElement("fieldset", { role: this.question.a11y_input_ariaRole, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-labelledby": this.question.a11y_input_ariaLabelledBy, "aria-describedby": this.question.a11y_input_ariaDescribedBy, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage },
                React.createElement("legend", { role: "presentation", className: "sv-hidden" }),
                !!this.question.hasMinLabel ? React.createElement("span", { className: cssClasses.minText }, minText) : null,
                this.question.renderedRateItems.map(function (item, index) { return _this.renderItem(item, index); }),
                !!this.question.hasMaxLabel ? React.createElement("span", { className: cssClasses.maxText }, maxText) : null)));
    };
    return SurveyQuestionRating;
}(SurveyQuestionElementBase));
export { SurveyQuestionRating };
ReactQuestionFactory.Instance.registerQuestion("rating", function (props) {
    return React.createElement(SurveyQuestionRating, props);
});
